import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import authService from '../../api/authService';

// Decode JWT payload without a library (base64 decode)
function decodeToken(token) {
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload));
    return { id: decoded.id, username: decoded.username, role: decoded.role };
  } catch {
    return null;
  }
}

const storedToken = localStorage.getItem('token');
const storedUser = storedToken ? decodeToken(storedToken) : null;

// Login thunk — calls real backend
export const login = createAsyncThunk('auth/login', async (credentials, { rejectWithValue }) => {
  try {
    const { data } = await authService.login(credentials);
    const token = data.data.accessToken;
    const user = data.data.user;
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    return { token, user };
  } catch (err) {
    // Handle specific error codes
    if (err.response?.data?.code === 'EMAIL_NOT_VERIFIED') {
      return rejectWithValue('Veuillez vérifier votre email avant de vous connecter. Un email de vérification a été envoyé à votre adresse.');
    }
    const msg =
      err.response?.data?.message ||
      err.response?.data?.error ||
      "Nom d'utilisateur ou mot de passe incorrect";
    return rejectWithValue(msg);
  }
});

// Logout thunk
export const logout = createAsyncThunk('auth/logout', async () => {
  try { await authService.logout(); } catch { /* ignore */ }
  finally { localStorage.removeItem('token'); }
});

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: storedUser,   // decoded from token on page load
    token: storedToken,
    loading: false,
    error: null,
  },
  reducers: {
    clearAuth(state) {
      state.user = null;
      state.token = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(login.fulfilled, (state, { payload }) => { state.loading = false; state.user = payload.user; state.token = payload.token; })
      .addCase(login.rejected, (state, { payload }) => { state.loading = false; state.error = payload; })
      .addCase(logout.fulfilled, (state) => { state.user = null; state.token = null; });
  },
});

export const { clearAuth } = authSlice.actions;
export default authSlice.reducer;
